/** Floor for investor range min, and startup ask in USD (other currencies convert to this). */
export const MIN_INVESTMENT_AMOUNT = 50000;

/** Investor range floor in SEK. Other currencies stay at MIN_INVESTMENT_AMOUNT. */
export const MIN_INVESTMENT_AMOUNT_SEK = 500000;

/** Ceiling for investment amounts / ranges, in USD (other currencies convert from this). */
export const MAX_INVESTMENT_AMOUNT_USD = 200_000_000;

/** Min length for startup "Impressive factor". */
export const IMPRESSIVE_FACTOR_MIN_CHARS = 50;

/** Max length for startup "Impressive factor" (~8 profile sidebar lines / ~½ of prior long entries). */
export const IMPRESSIVE_FACTOR_MAX_CHARS = 400;
